import React, { createContext } from 'react';
import { Panels, Modals, EnumOrEmpty } from '../../../modules/dialogs/model';

export type DialogType = Panels | Modals;
export type DialogCtxData = {
  dialogId: EnumOrEmpty<DialogType>,
  setDialog: (dialog?: DialogType) => void;
};

export const DialogCtx = createContext({} as DialogCtxData);

type DialogCtxProviderType = {
  value: DialogCtxData;
  children: any;
};
export const DialogBox = ({
  value,
  children,
}: DialogCtxProviderType) => {
  return (
    <DialogCtx.Provider value={value}>
      {children}
    </DialogCtx.Provider>
  );
};


